<template>
  <div class="dropzone-box">
    <input class="dropzone-input-file" type="file" :name="uploadFieldName" @change="fileChange" accept="image/*">
    <p v-if="isInitial" v-html="placeholder"></p>
  </div>
</template>

<script>

  export default {
    props: {
      placeholder: {
        type: String,
        default: 'Drag your file(s) here to begin<br> or click to browse'
      },
      uploadFieldName: {
        type: String,
        default: 'image'
      }
    },
    data () {
      return {
        uploadedFile: null
      }
    },
    computed: {
      isInitial () {
        return this.uploadedFile === null
      }
    },
    methods: {
      fileChange (event) {
        if (event.target.files.length > 0) {
          this.$emit('fileChange', event.target.files[0])
        }
      }
    }
  }

</script>

<style lang="scss">
  .dropzone-box {
    position: relative;
    background: transparent;
    color: #85ace7;
    height: 200px;
    width: 200px;
    border: dashed 1px #85ace7;
    cursor: pointer;
  }
  
  .dropzone-input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 100%;
    position: absolute;
    cursor: pointer;
  }
  
  .dropzone-box:hover {
    background: rgba( 0, 0, 0, 0.5); /* when mouse over to the drop zone, change color */
    color: #85ace7;
  }
  
  .dropzone-box p {
    font-size: 1.2em;
    text-align: center;
    padding: 80px 0;
  }

</style>



// WEBPACK FOOTER //
// DropZone.vue?00092aef